import './styles/app.css';

import { configureApi, hydrateApp } from '@bemor/web-kit';

import { wrap } from '@/app';
import { routes } from '@/router';

configureApi({
    baseUrl: '/api',
    onUnauthorized: () => {
        if (
            typeof window !== 'undefined' &&
            !window.location.pathname.startsWith('/login')
        )
            window.location.assign(
                `/login?return=${encodeURIComponent(window.location.pathname + window.location.search)}`,
            );
    },
});

hydrateApp({ routes, wrap });
